export default "__VITE_ASSET__BmGiRVb5__"